import { useState, useEffect }  from 'react'
import { useJustificationPage}  from '../../contexts/JustificationPageContext'
import dayjs                    from 'dayjs'
import DateInput                from "../DateInput"   
import api                      from '../../services/api.js'
import '../../styles/TableFilter.css'

function JustificationPageFilter() {

    const { 

        selectedComparisionTypeId, 
        selectedComparisionDate, 
        setSelectedComparisionDate,
        updateFilter

    } = useJustificationPage()


    const [ _comparisionDateList,    _setComparisionDateList     ] = useState([])
    const [ _dateInputFilterFormat,  _setDateInputFilterFormat   ] = useState('year')
    const [ _dateFormatter,          _setDateFormatter           ] = useState(null)
    

    const fetchComparisionDates = async (isFirstLoad) => {

        // A guarda mora aqui, e não no useEffect, porque a função é chamada de
        // dois efeitos: o de `updateFilter` dispara na montagem, quando o tipo
        // ainda é null no contexto, e o template literal abaixo mandaria a
        // string "null" na URL (500 no backend). Mesmo padrão do PxoDateFilter.
        if(!selectedComparisionTypeId) return

        try{

            const response = await api.get(`/getComparisionDatesByTypeId/${selectedComparisionTypeId}`)
            
            const { formattedDates, dateInputFilterFormat, dateFormatter } = response.data

            _setComparisionDateList(formattedDates)
            _setDateInputFilterFormat(dateInputFilterFormat)
            _setDateFormatter(dateFormatter)
            
            if (isFirstLoad) setSelectedComparisionDate(formattedDates[0])

        }catch(error){
            console.log(error)
        }

    }


    useEffect(() => {

        fetchComparisionDates(false)

    }, [ updateFilter ])

    useEffect(() => {

        fetchComparisionDates(true)

    }, [selectedComparisionTypeId])
    
    return (

        <div className="flex gap-[10px] flex-row z-10 text-[0.8rem] text-nowrap">

            <DateInput 

                selectedDateType={_dateInputFilterFormat} 
                onChange={value => setSelectedComparisionDate(value)} 

                datesList={_comparisionDateList} 
                defaultValue={selectedComparisionDate? dayjs(selectedComparisionDate, _dateFormatter || 'MM/DD'): null}

            />

        </div>
    )
}

export default JustificationPageFilter